import { render, staticRenderFns } from "./_reply_record_message.vue?vue&type=template&id=1fa8119b&scoped=true&"
import script from "./_reply_record_message.vue?vue&type=script&lang=js&"
export * from "./_reply_record_message.vue?vue&type=script&lang=js&"
import style0 from "./_reply_record_message.vue?vue&type=style&index=0&id=1fa8119b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa8119b",
  null
  
)

export default component.exports